// import React from 'react';
// import PropTypes from 'prop-types';
// import classNames from 'classnames';
// import Select from 'react-select';
// import { styled } from "@mui/material/styles";
// import { withStyles } from "@mui/styles";
// import Typography from "@mui/material/Typography";
// import NoSsr from "@mui/material/NoSsr";
// import Paper from '@mui/material/Paper';
// import Chip from '@mui/material/Chip';
// import MenuItem from '@mui/material/MenuItem';
// import CancelIcon from '@mui/icons-material/Cancel';
// // import { emphasize } from '@mui/system';
// import { emphasize } from '@mui/material/styles';
// import IntegrationReactSelectNew from './IntegrationReactSelectNew';


// // old custom react component for select with search option component

// const styles = theme => ({
//   root: {
//     flexGrow: 1,
//   },
//   input: {
//     display: 'flex',
//     padding: 0,
//   },
//   valueContainer: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     flex: 1,
//     alignItems: 'center',
//   },
//   chip: {
//     margin: `${theme.spacing(0.5)} ${theme.spacing(0.25)}`,
//   },
//   chipFocused: {
//     backgroundColor: emphasize(
//       theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
//       0.08,
//     ),
//   },
//   noOptionsMessage: {
//     padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
//   },
//   singleValue: {
//     fontSize: 16,
//   },
//   placeholder: {
//     position: 'absolute',
//     left: 2,
//     fontSize: 16,
//   },
//   paper: {
//     position: 'absolute',
//     zIndex: 1,
//     marginTop: theme.spacing(1),
//     left: 0,
//     right: 0,
//   },
//   divider: {
//     height: theme.spacing(2),
//   },
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: '100%',
//     width: '100%',
//   },
// });


// function NoOptionsMessage(props) {
//   return (
//     <Typography
//       color="textSecondary"
//       className={props.selectProps.classes.noOptionsMessage}
//       {...props.innerProps}
//     >
//       {props.children}
//     </Typography>
//   );
// }

// function inputComponent({ inputRef, ...props }) {
//   return <div ref={inputRef} {...props} />;
// }

// function Control(props) {
//   return (
//     <IntegrationReactSelectNew
//       fullWidth
//       InputProps={{
//         inputComponent,
//         inputProps: {
//           className: props.selectProps.classes.input,
//           inputRef: props.innerRef,
//           children: props.children,
//           ...props.innerProps,
//         },
//       }}
//       {...props.selectProps.IntegrationReactSelectNewProps}
//     />
//   );
// }

// function Option(props) {
//   return (
//     <MenuItem
//       buttonRef={props.innerRef}
//       selected={props.isFocused}
//       component="div"
//       style={{
//         fontWeight: props.isSelected ? 500 : 400,
//       }}
//       {...props.innerProps}
//     >
//       {props.children}
//     </MenuItem>
//   );
// }

// function Placeholder(props) {
//   return (
//     <Typography
//       color="textSecondary"
//       className={props.selectProps.classes.placeholder}
//       {...props.innerProps}
//     >
//       {props.children}
//     </Typography>
//   );
// }

// function SingleValue(props) {
//   return (
//     <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
//       {props.children}
//     </Typography>
//   );
// }

// function ValueContainer(props) {
//   return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
// }


// function MultiValue(props) {
//   return (
//     <Chip
//       tabIndex={-1}
//       label={props.children}
//       className={classNames(props.selectProps.classes.chip, {
//         [props.selectProps.classes.chipFocused]: props.isFocused,
//       })}
//       onDelete={props.removeProps.onClick}
//       deleteIcon={<CancelIcon {...props.removeProps} />}
//     />
//   );
// }

// function Menu(props) {
//   return (
//     <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
//       {props.children}
//     </Paper>
//   );
// }

// const components = {
//   Control,
//   Menu,
//   MultiValue,
//   NoOptionsMessage,
//   Option,
//   Placeholder,
//   SingleValue,
//   ValueContainer,
// };

// class IntegrationReactSelect extends React.Component {
//   constructor(props){
//     super(props);
//     this.state = {
//       single: null,
//       multi: null,
//       changedValues: [],
//     }
// }
// componentWillMount(){
//   if(this.props.haveDefault){
//     const xx = [
//       ...this.props.defaultValue    
//     ].map(xx => ({
//       value: xx.label,
//       label: xx.label,
//     }));
//     this.setState({
//       single: xx
//     },()=>{
//       this.props.onSelect(this.state.single);
//     }
//   )
//   }
// }

// handleChange = name => value => {
//     this.setState({
//       [name]: value,
//     },()=>{
//       if(!this.props.multipleSelect){
//         this.props.onSelect(this.state.single);
//         console.log(this.state)
//       }else{
//         var xx = [
//           ...this.state.single
//         ];
//         this.props.onSelect(this.state.single);
//       }
//     });
//   };

//   componentDidMount(){
//     console.log(this.props.defaultValueSingle)
//     console.log(this.state)

//   }

//   render() {
//     const { classes, theme } = this.props; 
//     const selectStyles = {
//       input: base => ({
//         ...base,
//         color: theme.palette.text.primary,
//         '& input': {
//           font: 'inherit',
//         },
//       }),
//     };
//     const suggestions = [
//       ...this.props.content    
//     ].map(suggestion => ({
//       value: suggestion.label,
//       label: suggestion.label,
//     }));
//     return (
//       <div className={classes.root}>
//       <NoSsr>
//       <Select
//       IntegrationReactSelectNewProps={{
//         label: this.props.IntegrationReactSelectNewLabel,
//         InputLabelProps: {
//           shrink: true,
//         },
//       }}
//       classes={classes}
//       styles={selectStyles}
//       options={suggestions}
//       components={components}
//       value={this.state.single}
//       onChange={this.handleChange('single')}
//       placeholder={this.props.placeholder || "Select Something"}
//       isMulti={this.props.multipleSelect}
//     />
//   </NoSsr>
//   </div>
//     );
//   }
// }

// IntegrationReactSelect.propTypes = {
//   classes: PropTypes.object.isRequired,
//   theme: PropTypes.object.isRequired,
//   content: PropTypes.object.isRequired
// };

// export default styled(styles, { withTheme: true })(IntegrationReactSelect);


import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Select from 'react-select';
import {
  Typography,
  Paper,
  Chip,
  MenuItem,
  Box
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { emphasize } from '@mui/material/styles';
import NoSsr from '@mui/material/NoSsr';

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      sx={{ py: 1, px: 2 }}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <Box sx={{ width: '100%' }}>
      <div
        ref={props.innerRef}
        {...props.innerProps}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '6px 0',
        }}
      >
        {props.children}
      </div>
    </Box>
  );
}

function Option(props) {
  return (
    <MenuItem
      ref={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 600 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      sx={{
        position: 'absolute',
        left: 2,
        fontSize: 16,
      }}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function SingleValue(props) {
  return (
    <Typography
      sx={{ fontSize: 16 }}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function ValueContainer(props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        overflow: 'auto',
      }}
    >
      {props.children}
    </Box>
  );
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      sx={{
        m: '2px 4px 2px 0',
        backgroundColor: props.isFocused
          ? emphasize('#e0e0e0', 0.08)
          : undefined,
      }}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

function Menu(props) {
  return (
    <Paper
      square
      sx={{
        position: 'absolute',
        zIndex: 1,
        mt: 1,
        left: 0,
        right: 0,
      }}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class IntegrationReactSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      single: null,
    };
  }

  componentDidMount() {
    if (this.props.haveDefault) {
      const defaults = this.props.defaultValue.map(xx => ({
        value: xx.label,
        label: xx.label,
      }));
      this.setState({ single: defaults }, () => {
        this.props.onSelect(this.state.single);
      });
    }
  }

  handleChange = name => value => {
    this.setState({ [name]: value }, () => {
      this.props.onSelect(this.state.single);
    });
  };

  render() {
    const { content, placeholder, multipleSelect, IntegrationReactSelectNewLabel, theme } = this.props;

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    const suggestions = content.map(suggestion => ({
      value: suggestion.label,
      label: suggestion.label,
    }));

    return (
      <Box sx={{ flexGrow: 1 }}>
        <NoSsr>
          <Select
            styles={selectStyles}
            options={suggestions}
            components={components}
            value={this.state.single}
            onChange={this.handleChange('single')}
            placeholder={placeholder || 'Select Something'}
            isMulti={multipleSelect}
          />
        </NoSsr>
      </Box>
    );
  }
}

IntegrationReactSelect.propTypes = {
  content: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  multipleSelect: PropTypes.bool,
  haveDefault: PropTypes.bool,
  defaultValue: PropTypes.array,
  onSelect: PropTypes.func.isRequired,
  IntegrationReactSelectNewLabel: PropTypes.string,
  theme: PropTypes.object.isRequired,
};

export default IntegrationReactSelect;
